import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

import VideoHero from "../components/VideoHero";
import GlobalScope from "../components/GlobalScope";
import InvestmentSection from "../components/InvestmentSection";
import HistorySection from "../components/HistorySection";
import CommitmentSection from "../components/CommitmentSection";
import CategoriesSection from "../components/CategoriesSection";

export default function Home() {

  useEffect(() => {
    document.title = "Home | My App";
  }, []);

  return (
    <>
      <VideoHero />
      <GlobalScope />
      <InvestmentSection />
      <HistorySection />
      <CommitmentSection />
      <CategoriesSection />

      <Container className="my-5">
        {/* <section className="my-4">
          <h2>About Us</h2>
          <p>We provide the best products for our customers.</p>
        </section> */}

        {/* <section className="my-4">
          <h2>Products</h2>
          <p>Check out our latest products.</p>
        </section> */}
      </Container>
    </>
  );
}
